export enum ENoteCategory {
  CAUTION = 'caution',
  ARRIVAL = 'arrival',
  DEPARTURE = 'departure',
  GROUND_OPERATIONS = 'ground_operations',
  RESTRICTIONS = 'restrictions',
  FLEET_INFORMATION = 'fleet_info'
}

export enum ENoteTag {
  ARRIVAL = 'arrival',
  DEPARTURE = 'departure',
  GROUND_OPERATIONS = 'ground'
}

export enum ENoteType {
  PROCEDURAL_NOTES = 'procedural_notes',
  OTHER_NOTES = 'other_notes'
}

export enum ECommentStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

export interface IAirportNotes {
  stations: Record<string, IAirportInfo>;
  notes: Record<string, INotes>;
  comments: Record<string, IComments>;
}

export interface IAirportInfo {
  id: string;
  cat?: string;
  timezone?: string;
  iata_code: string;
  icao_code: string;
  effective: string;
  country: string;
  version: string;
  published: string;
  references: IReference[];
  categories: ICategories;
  updated_at: string;
}

export interface ICategories {
  arrival: ICategory;
  departure: ICategory;
  ground_operations: ICategory;
  additional_information: ICategory;
  fleet_info: ICategory;
}

export interface ICategory {
  title: string;
  order: number;
  fleet: Record<string, IReference[]>;
}

export interface IReference {
  header: string;
  content: string;
}

export type INotes = Record<string, INoteInfo>;

export interface INoteInfo {
  airport: string;
  id: string;
  category: ENoteCategory;
  tags: ENoteTag[];
  content: string;
  summary?: string | null;
  is_new: boolean;
  created_by: string;
  created_at: string;
  approved_by: string;
  approved_at: string;
  rejected_by?: string;
  rejected_at?: string;
  comment_count: number;
  user_id?: string;
  updated_at?: string;
  airport_code?: string;
}

export type IComments = Record<string, ICommentInfo>;

export interface ICommentInfo {
  id: string;
  note_id: string;
  created_by: string;
  user_id: string;
  content: string;
  created_at: string;
  status: ECommentStatus;
  approved_by?: string;
  approved_at?: string;
  rejected_by?: string;
  rejected_at?: string;
  likes?: ILikes | undefined;
  airport?: string;
  airport_code?: string;
}

export interface ILikes {
  user_id: boolean;
}
